/* eslint-disable camelcase */
const teacher_pro = {
  versions: {
    50: {
      billingPeriods: {
        yearly: {
          interval: "yearly",
          usd: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_50_YEARLY_USD,
            currency: "usd",
            amount: 22400,
            interval: "yearly",
          },
          eur: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_50_YEARLY_EUR,
            currency: "eur",
            amount: 21000,
            interval: "yearly",
          },
          gbp: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_50_YEARLY_GBP,
            currency: "gbp",
            amount: 19900,
            interval: "yearly",
          },
          cad: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_50_YEARLY_CAD,
            currency: "cad",
            amount: 29900,
            interval: "yearly",
          },
        },
      },
    },
    100: {
      billingPeriods: {
        yearly: {
          interval: "yearly",
          usd: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_100_YEARLY_USD,
            currency: "usd",
            amount: 39900,
            interval: "yearly",
          },
          eur: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_100_YEARLY_EUR,
            currency: "eur",
            amount: 37500,
            interval: "yearly",
          },
          gbp: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_100_YEARLY_GBP,
            currency: "gbp",
            amount: 34900,
            interval: "yearly",
          },
          cad: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_100_YEARLY_CAD,
            currency: "cad",
            amount: 53500,
            interval: "yearly",
          },
        },
      },
    },
    200: {
      billingPeriods: {
        yearly: {
          interval: "yearly",
          usd: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_200_YEARLY_USD,
            currency: "usd",
            amount: 29900,
            interval: "yearly",
          },
          eur: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_200_YEARLY_EUR,
            currency: "usd",
            amount: 29900,
            interval: "yearly",
          },
          gbp: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_200_YEARLY_GBP,
            currency: "usd",
            amount: 29900,
            interval: "yearly",
          },
          cad: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_TEACHER_PRO_200_YEARLY_CAD,
            currency: "usd",
            amount: 29900,
            interval: "yearly",
          },
        },
      },
    },
    300: {
      billingPeriods: {
        yearly: {
          interval: "yearly",
          usd: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_300_YEARLY_USD,
            currency: "usd",
            amount: 99900,
            interval: "yearly",
          },
          eur: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_300_YEARLY_EUR,
            currency: "eur",
            amount: 89900,
            interval: "yearly",
          },
          gbp: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_300_YEARLY_GBP,
            currency: "gbp",
            amount: 82500,
            interval: "yearly",
          },
          cad: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_300_YEARLY_CAD,
            currency: "cad",
            amount: 139900,
            interval: "yearly",
          },
        },
      },
    },
    500: {
      billingPeriods: {
        yearly: {
          interval: "yearly",
          usd: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_500_YEARLY_USD,
            currency: "usd",
            amount: 269900,
            interval: "yearly",
          },
          eur: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_500_YEARLY_EUR,
            currency: "eur",
            amount: 249900,
            interval: "yearly",
          },
          gbp: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_500_YEARLY_GBP,
            currency: "gbp",
            amount: 219900,
            interval: "yearly",
          },
          cad: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_500_YEARLY_CAD,
            currency: "cad",
            amount: 359900,
            interval: "yearly",
          },
        },
      },
    },
    1000: {
      billingPeriods: {
        yearly: {
          interval: "yearly",
          usd: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_1000_YEARLY_USD,
            currency: "usd",
            amount: 499900,
            interval: "yearly",
          },
          eur: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_1000_YEARLY_EUR,
            currency: "eur",
            amount: 459900,
            interval: "yearly",
          },
          gbp: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_1000_YEARLY_GBP,
            currency: "gbp",
            amount: 399900,
            interval: "yearly",
          },
          cad: {
            priceId:
              process.env.REACT_APP_STRIPE_PRICE_SCHOOL_PRO_1000_YEARLY_CAD,
            currency: "cad",
            amount: 669900,
            interval: "yearly",
          },
        },
      },
    },
  },
};

export default teacher_pro;
